import { action } from "../common/Action"
import { BruciatoriClient } from "../generated";

const service = new BruciatoriClient();

class MarcheCaldaieActions {
    @action
    async search(searchValue: string) {
        return service
            .getMarcheBruciatoriList(searchValue)
            .then(marche => ({
                searchValue,
                marche: marche!,
            }));

    };
}
export default new MarcheCaldaieActions();